import { Component, Schema } from "minecs";

@Component()
export class CameraFollowOnSpawn extends Schema {}
